import { observer } from "mobx-react-lite";

import { NodePointer } from "@/components/doc/right-sidebar/node-viewer/NodePointer";
import { NodeColorProperty } from "@/components/doc/right-sidebar/node-viewer/properties/NodeColorProperty";
import { NodeNameProperty } from "@/components/doc/right-sidebar/node-viewer/properties/NodeNameProperty";
import { NodeTypeProperty } from "@/components/doc/right-sidebar/node-viewer/properties/NodeTypeProperty";
import { NodeUnitProperty } from "@/components/doc/right-sidebar/node-viewer/properties/NodeUnitProperty";
import { NodeValueProperty } from "@/components/doc/right-sidebar/node-viewer/properties/NodeValueProperty";
import { useNodeTheme } from "@/components/expression/theme";
import { getDerivedUnitText } from "@/components/suggestions/providers/utils/getPhantomHints";
import { isNodeEditable } from "@/components/tiptap/lock/utils";
import { type VariableNodeModel } from "@/models/nodes/VariableNodeModel";

type Props = {
  node: VariableNodeModel;
  ids: Set<string>;
};

export const NodeVariable = observer(function NodeVariable({ node, ids }: Props) {
  const theme = useNodeTheme(node);
  const hasDerivedUnit = !node.unitNode && getDerivedUnitText(node.doc, node.labeledValue) !== null;

  return (
    <>
      <NodePointer>
        <NodeTypeProperty node={node} ids={ids} />
      </NodePointer>
      {(isNodeEditable(node) || node.value) && (
        <NodePointer>
          <NodeValueProperty node={node} ids={ids} />
        </NodePointer>
      )}
      {(isNodeEditable(node) || node.name) && (
        <NodePointer>
          <NodeNameProperty node={node} />
        </NodePointer>
      )}
      {(node.unitNode || hasDerivedUnit) && (
        <NodePointer>
          <NodeUnitProperty node={node} />
        </NodePointer>
      )}
      {theme.background.type === "colored" && (
        <NodePointer>
          <NodeColorProperty node={node} />
        </NodePointer>
      )}
    </>
  );
});
